/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_SearchInputs */

const cs_gdpr_search = /** @type {(inputs: Gdpr_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat`)
};

const en_gdpr_search = /** @type {(inputs: Gdpr_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Gdpr_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_search = /** @type {((inputs?: Gdpr_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_search(inputs)
	return cs_gdpr_search(inputs)
});